import REACT_APP_URLS from '../../../../global-helpers/global-url.helpers';
import { store } from '../../../../store/store';
import axios from 'axios';
import { TOKEN_KEY } from '../../../../constants/constants';
import { INewsForgeGeneratedArticle } from '../models/news-forge.models';

const baseURL = REACT_APP_URLS.REACT_APP_CONTENT_API_BASE_URL;

export default class NewsForgeHttpService {
	static getGeneralInstanceHeaders = () => {
		const reduxState = store.getState();

		return {
			Project: `${reduxState.project.currentProject.domain}`,
			'Content-Type': 'application/json',
			Authorization: localStorage.getItem(TOKEN_KEY),
		};
	};

	static instance = () => {
		return axios.create({
			baseURL,
			timeout: 30000,
			headers: {
				...NewsForgeHttpService.getGeneralInstanceHeaders(),
			},
		});
	};

	static extractAndTranslate = (target_url: string) => {
		return NewsForgeHttpService.instance().post(`/newsforge/generate`, { target_url });
	};

	static translateContent = (data: { title: string; content: string }) => {
		return NewsForgeHttpService.instance().post(`/newsforge/translate`, data);
	};

	static createdExtractedArticle = (data: INewsForgeGeneratedArticle) => {
		return NewsForgeHttpService.instance().post(`/newsforge/articles`, data);
	};

	static getJobPolling = (id: string) => {
		return NewsForgeHttpService.instance().get(`/newsforge/jobs/${id}`);
	};
}
